import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";

export function Footer() {
  const { t } = useI18n();
  return (
    <footer
      className="bg-[#05073B] text-slate-300"
      data-testid="public-footer"
    >
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="grid gap-12 md:grid-cols-4">
          <div>
            <img
              src="/brand/neuracom-logo-white.png"
              alt="NEURACOM"
              style={{ height: 56, width: "auto", display: "block" }}
              data-testid="footer-logo"
              draggable={false}
            />
            <p className="mt-4 max-w-xs text-sm text-slate-400">
              {t("footer.tagline")}
            </p>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#9ACD32]">
              {t("footer.product")}
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link
                  to="/pricing"
                  className="hover:text-white transition-colors"
                  data-testid="footer-pricing"
                >
                  {t("common.pricing")}
                </Link>
              </li>
              <li>
                <Link
                  to="/affiliate"
                  className="hover:text-white transition-colors"
                  data-testid="footer-affiliate"
                >
                  {t("common.partner_program")}
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="hover:text-white transition-colors"
                  data-testid="footer-blog"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/marketplace"
                  className="hover:text-white transition-colors"
                  data-testid="footer-marketplace"
                >
                  Marketplace
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/jurisprudence"
                  className="hover:text-white transition-colors"
                  data-testid="footer-jurisprudence"
                >
                  {t("nav.jurisprudence") || "Jurisprudence"}
                </Link>
              </li>
              <li>
                <Link
                  to="/auth?mode=signup"
                  className="hover:text-white transition-colors"
                  data-testid="footer-signup"
                >
                  {t("common.try_free")}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#9ACD32]">
              {t("footer.legal")}
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link
                  to="/terms"
                  className="hover:text-white transition-colors"
                  data-testid="footer-terms"
                >
                  {t("footer.terms")}
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="hover:text-white transition-colors"
                  data-testid="footer-privacy"
                >
                  {t("footer.privacy")}
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="hover:text-white transition-colors"
                  data-testid="footer-cookies"
                >
                  {t("footer.cookies")}
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-center"
                  className="hover:text-white transition-colors"
                  data-testid="footer-privacy-center"
                >
                  {t("footer.privacy_center")}
                </Link>
              </li>
            </ul>
          </div>
          <div data-testid="footer-contact-column">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#9ACD32]">
              {t("footer.contact")}
            </h4>
            <address className="mt-4 not-italic text-sm leading-relaxed text-slate-400">
              <p className="font-semibold text-slate-200" data-testid="footer-company-name">TelcaVoIP International EU</p>
              <p className="mt-1">Ul. Zbozowa 4A<br />70-653 Szczecin, Poland</p>
              <p className="mt-2 font-mono text-xs text-slate-500" data-testid="footer-vat">VAT PL8513242072</p>
              <p className="mt-3">
                <a href="tel:+390427881500" className="block hover:text-white" data-testid="footer-tel-it">
                  <span className="text-slate-500">IT</span> +39 0427 881500
                </a>
                <a href="tel:+48573187804" className="mt-1 block hover:text-white" data-testid="footer-tel-pl">
                  <span className="text-slate-500">PL</span> +48 573 187 804
                </a>
              </p>
              <p className="mt-3">
                <a href="mailto:support@telcavoip.eu" className="block hover:text-white" data-testid="footer-email-support">
                  support@telcavoip.eu
                </a>
                <a href="mailto:privacy@telcavoip.eu" className="mt-1 block hover:text-white" data-testid="footer-email-privacy">
                  privacy@telcavoip.eu
                </a>
              </p>
            </address>
          </div>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-slate-800 pt-6 text-xs text-slate-500">
          <span>{t("footer.copyright")}</span>
          <a
            href="https://telcavoip.ai"
            target="_blank"
            rel="noreferrer noopener"
            className="inline-flex items-center gap-1.5 rounded-full border border-[#9ACD32]/30 bg-[#9ACD32]/5 px-3 py-1.5 text-[11px] font-semibold text-slate-300 transition-colors hover:border-[#9ACD32]/60 hover:text-white"
            data-testid="ai-powered-badge"
          >
            <span>AI Powered with</span>
            <span aria-label="love" className="text-[#9ACD32]">♥</span>
            <span>by</span>
            <span className="font-bold text-[#9ACD32]">TelcaVoIP AI</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
